var map = {
	"./IconButton.vue": "szsi",
	"./RadioInput.vue": "wv+o",
	"./ResultValue.vue": "uiBH",
	"./SelectInput.vue": "ft2c",
	"./SliderInput.vue": "jc/0",
	"./SvgIcon.vue": "VYBW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6fpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/base nonrecursive [A-Z]\w+\.(vue|js)$
// module id = 6fpg
// module chunks = 12